// @ts-nocheck
/* eslint-disable */
// Set your APP_ID
import * as Sentry from '@sentry/react';

export const APP_ID = 'b2dpow3j';

// Loads Intercom with the snippet
// This must be run before boot, it initializes window.Intercom
// prettier-ignore
export const load = () => {
  (function(){const w=window;const ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{const d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;const l=function(){const s=d.createElement('script');s.type='text/javascript';s.async=true;s.src=`https://widget.intercom.io/widget/${  APP_ID}`;const x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
}

// Initializes Intercom
export const boot = (options = {}) => {
  window && window.Intercom && window.Intercom('boot', { app_id: APP_ID, ...options });
};

// This method just calls Intercom('update'), which should be run on every page
// change. This does two things:
// 1. Send an update to Intercom to create an impression on the current URL
// 2. Fetch any messages that should be delivered based on the URL and user
export const update = (options = {}) => {
  window && window.Intercom && window.Intercom('update', options);
};

export const show = (message?: string) => {
  window && window.Intercom && window.Intercom(message ? 'showNewMessage' : 'show', message);
};

// Clears user session and unloads messages
export const shutdown = () => {
  try {
    window && window.Intercom && window.Intercom('shutdown');
  } catch (e) {
    console.error('Intercome::shutdown', e);
    Sentry.captureException(e);
  }
};

export const addIntercomListener = (event: 'onHide', cb) => {
  window && window.Intercom && window.Intercom(event, cb);
};
